<mat-icon>info</mat-icon>
<div *ngIf="title">{{title}}</div>
<div>{{ message }}</div>
